export default {
      id: "repair-usage",
      viewBox: "0 0 22 21",
      url: __webpack_public_path__ + "img/icons.svg#repair",
      toString: function () {
        return this.url;
      }
    }